import React from "react";
import { useViewport } from "@bookingcom/bui-react";
import { mcn } from "../../../utils/mergeClassnames.js";
import Frame from "../Frame/index.js";
import styles from "./Container.module.css";
const Container = (props) => {
    const { isLarge } = useViewport();
    const { children, justify = "center", align = "start", position = "relative", id, innerRef, className } = props;
    return (React.createElement(Frame, { justifyContent: justify, alignItems: align, direction: "row", p: props.p, pt: props.pt, pr: props.pr ?? 4, pb: props.pb, pl: props.pl ?? 4, attributes: { style: { ...props.style, width: "100%" } }, className: className },
        React.createElement("div", { ref: innerRef, id: id, style: { position }, className: mcn(styles.container, !isLarge && styles.containerRes) }, children)));
};
export { Container as default };
